import { createImageSrc } from '../partials/image/image.utils';

export interface PageImage {
    host: string;
    path: string;
}

export const createImageAttributes = (pageImage: PageImage) => {
  const imageAspectRatioX = 16;
  const imageAspectRatioY = 9;
  const aspectRatio = {
    x: imageAspectRatioX,
    y: imageAspectRatioY,
  };
  const imageWidth = 600;
  const imageUrl = createImageSrc(pageImage.host, pageImage.path, imageWidth, aspectRatio, 1);
  const imageHeight = `${(Number(imageWidth) * imageAspectRatioY) / imageAspectRatioX}`;
  return {
    imageUrl,
    imageHeight,
    imageWidth,
  };
};
